<template>
  <div class="container">
    <div class="alert alert-success mt-4 mb-4" v-if="message">
      {{ message }}
    </div>
    <div class="signup-form">
      <form @submit.prevent="sendrequest">
        <h2 style="colo: black">Inviaci la tua richiesta</h2>
        <p>
          Compila tutti i campi e inviaci la tua richiesta! Entro 48h riceverai
          una email con la nostra risposta
        </p>
        <hr />
        <div class="form-group">
          <div class="row">
            <div class="col">
              <input type="text" class="form-control" v-model="register.name" placeholder="Nome" required="required" />
              <div class="alert alert-danger" v-if="errors.name">
                {{ errors.name[0] }}
              </div>
            </div>
            <div class="col">
              <input type="text" class="form-control" v-model="register.lastname" placeholder="Cognome"
                required="required" />
              <div class="alert alert-danger" v-if="errors.lastname">
                {{ errors.lastname[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col">
              <input type="email" class="form-control" v-model="register.email" placeholder="Email"
                required="required" />
              <div class="alert alert-danger" v-if="errors.email">
                {{ errors.email[0] }}
              </div>
            </div>
            <div class="col">
              <input type="text" class="form-control" v-model="register.phone" placeholder="Recapito telefonico"
                required="required" />
              <div class="alert alert-danger" v-if="errors.phone">
                {{ errors.phone[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <select class="form-control" id="specializzazione" required="required" v-model="register.qualification_id"
                @change="qualificationChange">
                <option value="0" selected disabled>
                  Seleziona il reparto
                </option>
                <option v-for="(qualification, index) in qualifications" :key="index" :value="qualification.id">
                  {{ qualification.name }}
                </option>
              </select>
              <div class="alert alert-danger" v-if="errors.specialisation_id">
                {{ errors.specialisation_id[0] }}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <select class="form-control" v-model="register.specialisation_id">
                <option value="0" selected disabled>
                  Seleziona la qualifica
                </option>
                <option v-for="(specialisation, index) in specialisations" :key="index" :value="specialisation.id">
                  {{ specialisation.name }}
                </option>
              </select>
              <div class="alert alert-danger" v-if="errors.qualification_id">
                {{ errors.qualification_id[0] }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" name="ospedale" v-model="register.hospital"
            placeholder="Ospedale o istituzione di competenza " required="required" />
          <div class="alert alert-danger" v-if="errors.hospital">
            {{ errors.hospital[0] }}
          </div>
        </div>

        <div class="custom-control custom-checkbox">
          <input type="checkbox" name="controllo" class="custom-control-input" id="defaultUnchecked"
            v-model="register.privacy_general" :value="true" required />
          <label class="custom-control-label" for="defaultUnchecked">
            Ho Letto l’informativa privacy e confermo di voler
            procedere alla mia registrazione al sito (neurohub.it) (punto 6 dell’informativa privacy).
          </label>
          <div class="alert alert-danger" v-if="errors.privacy_general">
            {{ errors.privacy_general[0] }}
          </div>
        </div>

        <div class="custom-control custom-checkbox">
          <input type="checkbox" name="controllo" class="custom-control-input" id="privacyMessage" :value="true"
            v-model="register.privacy_message" />
          <label class="custom-control-label" for="privacyMessage">
            Presto il consenso al trattamento dei miei dati per permettere agli altri utenti del sito di conoscere le
            mie generalità e quindi di inviarmi messaggi privati aventi ad oggetto il caso clinico (punto 8
            dell’informativa privacy).
          </label>
          <div class="alert alert-danger" v-if="errors.privacy_message">
            {{ errors.privacy_message[0] }}
          </div>
        </div>

        <div class="custom-control custom-checkbox">
          <input type="checkbox" name="controllo" class="custom-control-input" id="privacyNews" :value="true"
            v-model="register.privacy_newsletter" />
          <label class="custom-control-label" for="privacyNews">
            Presto il consenso al ricevimento di comunicazioni (Newsletter) riguardanti webinar oppure altri servizi
            offerti dalla piattaforma (si veda punto 5 dell’informativa privacy).
          </label>
          <div class="alert alert-danger" v-if="errors.privacy_newsletter">
            {{ errors.privacy_newsletter[0] }}
          </div>
        </div>

        <div class="form-group" style="text-align: center">
          <button type="submit" class="btn btn-primary btn-lg">
            Invia la richiesta
          </button>
        </div>
      </form>
      <div class="hint-text">
        Hai già un account? <a href="/login">Accedi subito</a>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/services/http.js";
export default {
  name: "RegisterPage",
  props: {},
  data() {
    return {
      data: [],
      errors: [],
      qualifications: [],
      specialisations: [],
      register: {
        email: "",
        lastname: "",
        name: "",
        phone: "",
        qualification_id: 0,
        specialisation_id: 0,
        hospital: "",
        privacy_general: false,
        privacy_newsletter: false,
        privacy_message: false
      },
      message: "",
      user: "",
      checkCompany: false,
    };
  },
  mounted() {
    this.qualificationsData();
    this.specialisationsData();
  },
  methods: {
    async qualificationsData() {
      var { data } = await http.get("/qualifications");

      this.qualifications = data.data;
    },
    async specialisationsData() {
      var { data } = await http.get("/specialisations");
      this.specialisations = data.data;
    },
    qualificationChange() {
      this.checkCompany = false;
    },
    sendrequest() {
      try
      {
        http
          .post("/request-users/store", this.register)
          .then((response) => {
            this.message = response.data.message;
            this.register = {
              email: "",
              lastname: "",
              name: "",
              phone: "",
              qualification_id: 0,
              specialisation_id: 0,
              hospital: "",
              company: "",
              privacy_general: false,
              privacy_newsletter: false,
              privacy_message: false
            };
            // Gestisci l'array di oggetti come desiderato
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      } catch (error)
      {
        this.errors = error.response.data.errors;
      }
    },
  },
};
</script>